import React, { useEffect, useState } from "react";
import bigInt from "big-integer";
import {
  Grid,
  makeStyles,
  Typography,
  Button,
  TextField,
  Box,
} from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { connect } from "react-redux";
import styles from "../../../../styles/global-styles";
import { actions } from "../../../../redux/actions/alert";
import { ChipService } from "../../../../services/chip.service";
import { useHistory } from "react-router-dom";

const usetSyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  formControl: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      width: 240,
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  label: {
    marginBottom: "1.5vh",
  },
  inputBoxSpace: styles.inputBoxSpace,
  backgroundIcon: styles.backgroundIcon,
  box: {
    marginTop: "30px",
  },
}));

const AddChipToInventory = ({
  addAlert,
  detailAlert,
  detailProduct,
  bulkChipCreated,
  iccidArray,
}) => {
  const classes = usetSyles();
  const history = useHistory();

  const [isSizeIccid, setIsSizeIccid] = useState(false);
  const [chipBulk, setChipBulk] = useState([]);
  const iccidLength = detailProduct.sizeIccid?.toString() || 0;
  let tmpArray = [];

  useEffect(() => {
    if (Object.values(detailProduct).length > 0 && detailProduct.sizeIccid) {
      setIsSizeIccid(true);
    }
  }, []);

  useEffect(() => {
    (async function () {
      if (chipBulk.length) {
        try {
          const { data } = await ChipService.createBulkChip(chipBulk);
          const bulkArray = data.map((product, i) => {
            const chipInfo = { ...product, ...chipBulk[i] };
            return chipInfo;
          });
          console.log("FINAL bulk array", bulkArray);
          bulkChipCreated(bulkArray);
        } catch (error) {
          console.log("error", error);
          setTimeout(() => history.push("/dashboard/inventario/chips"), 2300);
          addAlert({ showAlert: true });
          detailAlert({ severity: "error", message: error.msgs });
        }
      }
    })();
  }, [chipBulk]);

  const buildIcciInput = () => {
    tmpArray = [];
    for (
      let i = bigInt(detailProduct.iccidInit).value;
      i <= bigInt(detailProduct.iccidEnd).value;
      i++
    ) {
      tmpArray.push(i);
    }
    return tmpArray.map((v, i) => {
      return (
        <Grid key={i} item sm={6} md={6} lg={4} xl={4}>
          <Box key={i} className={classes.box}>
            <Typography
              variant="body2"
              component={"div"}
              className={classes.label}
            >
              ICCID
            </Typography>
            <TextField
              name="iccid"
              value={v.toString()}
              validators={["required"]}
              disabled={true}
              variant="outlined"
            ></TextField>
          </Box>
        </Grid>
      );
    });
  };

  const continueToDistribtuion = () => {
    delete detailProduct.iccidInit;
    delete detailProduct.iccidEnd;
    delete detailProduct.sizeIccid;
    const copyChipBulk = [...chipBulk];
    tmpArray.forEach((iccid, i) => {
      copyChipBulk[i] = {
        ...detailProduct,
        iccid: iccid.toString(),
        inDistribution: 0,
        siteId: 1,
      };
    });
    setChipBulk(copyChipBulk);
  };

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justify="space-around"
        alignItems="center"
      >
        {detailProduct && (
          <Grid item xs={12}>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold" }}
              component={"div"}
            >
              Chip {detailProduct.chipName}
            </Typography>
            <Typography
              variant="body1"
              style={{ fontWeight: "bold" }}
              component={"div"}
            ></Typography>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{ marginTop: "30px" }}
        >
          <Typography
            variant="subtitle1"
            component={"div"}
            className={classes.label}
          >
            {iccidLength} registros de ICCID van a ser guardados
          </Typography>
        </Grid>
        {isSizeIccid && buildIcciInput()}

        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "20px", width: 150 }}
            onClick={continueToDistribtuion}
            endIcon={
              <ArrowRightAltIcon
                className={classes.backgroundIcon}
                color="primary"
              />
            }
          >
            Continuar
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(AddChipToInventory);
